import axios, { createSecureAxios } from '@/tools/axios/axios'
import MEGAPHONE from '@/web/store/types/megaphone'
import PRODUCT from '@/web/store/registered/product'
import PRODUCT_LIST from '@/web/store/registered/product-list'
import { storage } from '@/tools/storage'

const API_URL = '/api/megaphones'
const API_VERSION = 'v1'

const METRICS_MODAL_PARAMS = { isOpened: true, type: 'metrics'}
const ERROR_FEEDBACK_TIME = 4000

export default {
  [MEGAPHONE.ACTIONS.LOAD]: ({ commit }, productIds) => {
    const params = {
      product_ids: productIds.join(','),
      version: API_VERSION
    }

    axios.get(`${API_URL}/v1`, { params })
      .then((response) => {
        commit(MEGAPHONE.MUTATIONS.SET_PRODUCTS, response.data.products)
        commit(MEGAPHONE.MUTATIONS.SET_MESSAGES, response.data.messages)
      })
  },
  [MEGAPHONE.ACTIONS.BOOST]: async ({ commit, state, dispatch }, payload) => {
    // When action is called by product card,
    // we must to set the product to boost

    let productId = null

    if (payload.productId) {
      commit(MEGAPHONE.MUTATIONS.SET_PRODUCT_TO_BOOST, parseInt(payload.productId, 10))

      // If the second step is required,
      // we stop the propagation
      if (state.modal.isOpened) {
        return false
      }

      productId = payload.productId
    } else {
      productId = state.productToBoost
    }

    const secureAxios = await createSecureAxios()

    const data = {
      version: API_VERSION,
      product_id: productId,
      new_price: payload.newPrice,
      plan_id: payload.upgradeablePlanId
    }

    return secureAxios.post(API_URL, data)
    .then((response) => {
      commit(MEGAPHONE.MUTATIONS.UPDATE_PRODUCT, { ...response.data, product_id: productId })
      commit(MEGAPHONE.MUTATIONS.SET_MODAL_IS_OPENED, false)

      if (payload.newPrice) {
        dispatch(PRODUCT.ACTIONS.LOAD, null, { root: true })
        dispatch(PRODUCT_LIST.ACTIONS.CHANGE_PRICES, { id: productId, priceTo: payload.newPrice }, { root: true })
      }
    }).catch(() => {
      commit(MEGAPHONE.MUTATIONS.SET_BOOST_ACTION_ERROR, { productId: productId, hasError: true })
      setInterval(() => {
        commit(MEGAPHONE.MUTATIONS.SET_BOOST_ACTION_ERROR, { productId: null, hasError: false })
      }, ERROR_FEEDBACK_TIME)
    }).then(() => {
      commit(MEGAPHONE.MUTATIONS.SET_PRODUCT_TO_BOOST, null)
    })
  },
  [MEGAPHONE.ACTIONS.SHOW_METRICS]: ({ commit }, productId) => {
    commit(MEGAPHONE.MUTATIONS.SET_MODAL_PARAMS, {
      ...METRICS_MODAL_PARAMS,
      isFetching: true
    })

    axios.get(`${API_URL}/metrics`, {
      params: {
        version: API_VERSION,
        product_id: productId
      }
    }).then((response) => {
      commit(MEGAPHONE.MUTATIONS.SET_MODAL_PARAMS, {
        ...METRICS_MODAL_PARAMS,
        ...response.data,
        isFetching: false
      })
    }).catch(() => {
      commit(MEGAPHONE.MUTATIONS.SET_BOOST_ACTION_ERROR, { productId: state.productToBoost, hasError: true })
      setInterval(() => {
        commit(MEGAPHONE.MUTATIONS.SET_BOOST_ACTION_ERROR, { productId: null, hasError: false })
      }, ERROR_FEEDBACK_TIME)
    })
  },
  [MEGAPHONE.ACTIONS.LOAD_STATS]: ({ commit }) => {
    if (storage.local.get('megaphoneEnabled')) {
      commit(MEGAPHONE.MUTATIONS.SET_STATS, true)
    } else {
      axios.get(`${API_URL}/stats`, {
        params: {
          version: API_VERSION
        }
      }).then((response) => {
        commit(MEGAPHONE.MUTATIONS.SET_STATS, response.data.enabled)

        if (response.data.enabled) {
          storage.local.set('megaphoneEnabled', true)
        }
      }).catch(() => {
        commit(MEGAPHONE.MUTATIONS.SET_STATS, false)
      })
    }
  }
}
